import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { apiDeleteBusiness, apiGetBusiness, apiGetBusinesses, apiLeaveBusiness } from "api/businessApi";
import { appReset, appSetToggle, setConfirm } from "store/actions/appAction";
import { setBusiness } from "store/actions/businessAction";

import IconHeader from "assets/svg/icon-header-show-account.svg";
import IconHome from "assets/svg/icon-home-show-account.svg";
import IconMenu from "assets/svg/icon-menu-account.svg";
import IconKey from "assets/svg/icon-key-account.svg";
import IconNote from "assets/svg/icon-nodepad-account.svg";
import IconArrowLeft from "assets/svg/arrow-left-show-account.svg";
import IconBaketShow from "assets/svg/icon-basket-show-account.svg";
import IconDelete from "assets/svg/icon-delete-show-account.svg";
import IconMenuAz from "assets/svg/icon-menu-arzi.svg";
import IconAddNewAccount from "assets/svg/icon-add-new-account.svg";
import IconAddNewAccountHover from "assets/svg/icon-add-new-account-hover.svg";
import addWork from "assets/svg/registerShow/icon-add-work.svg";

import "assets/styles/register/registerShow.scss";

import { styled } from "@mui/material";
import LeaveIcon from "assets/icons/LeaveIcon";

const WrapBody = styled("div")(({ theme }) => ({
    width: "100%",
    [theme.breakpoints.down("xl")]: {
        width: "62%",
    },
    [theme.breakpoints.down("lg")]: {
        width: "62%",
    },
    [theme.breakpoints.down("md")]: {
        width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
        width: "100%",
    },
}));

export default function Businesses() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const extendBusinessId = location.state?.extendBusinessId;

    const store = useSelector((state) => state);
    const toggle = useSelector((state) => state).appReducer.toggle;
    const businesses = useSelector((state) => state).businessReducer.businesses;
    const business = useSelector((state) => state).businessReducer.business;
    const user = store.userReducer.user;
    const token = user?.token;
    const [showMenu, setShowMenu] = useState(false);
    const [menuBusinessId, setMenuBusinessId] = useState(0);

    useEffect(() => {
        constructor();
        //     checkForExtend();
    }, [business]);

    // useEffect(() => {
    // constructor();
    // checkForExtend();
    // }, [businesses]);

    useEffect(() => {
        if (!toggle) setShowMenu(toggle);
    }, [toggle]);

    const constructor = () => {
        if (business && !extendBusinessId && business.business?.subscriptionTitle !== "منقضی شده") {
            navigate("/dashboard");
        } else {
            dispatch(apiGetBusinesses(token, navigate));
            dispatch(appReset());
        }
    };

    const checkForExtend = () => {
        if (extendBusinessId) {
            const business = businesses.find((b) => b.id === extendBusinessId);
            if (business) {
                dispatch(setBusiness({ business }));
                navigate("/business/extend");
            }
        }
    };

    const loadBusiness = (business) => {
        dispatch(apiGetBusiness(business, token, (res) => {
            constructor();
        }));
    };

    function showBusinessMenu(id) {
        setMenuBusinessId(id ?? 0);
        setShowMenu(id ?? false);
        dispatch(appSetToggle(id ?? false));
    }
    return (
        <div className="mr-0 wrap-show-account row ">
            <WrapBody className="col-lg-12 col-md-12 col-sm-12 col-xs-12 warp-header">
                <div>
                    <img src={IconHeader} alt="IconHeader" />
                    کسب و کار های شما
                </div>
            </WrapBody>

            <WrapBody className="col-lg-12 col-md-12 col-sm-12 col-xs-12 warp-body ">
                <div className="px-3 box-items row">
                    {businesses.map((business) => {
                        const canDelete = ["مدیر", "مالک"].includes(business?.userRole);
                        return (
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" key={business.id}>
                                <div className="item">
                                    <div
                                        className={
                                            toggle && showMenu && menuBusinessId === business.id
                                                ? "active-toggle-menu-account"
                                                : "not-active-toggle-menu-account"
                                        }
                                    >
                                        {/*<div>*/}
                                        {/*    <img src={IconEdit} alt="IconEdit"/>*/}
                                        {/*    ویرایش*/}
                                        {/*</div>*/}
                                        <div
                                            onClick={() => {
                                                dispatch(setBusiness({ business }));
                                                navigate("/business/extend");
                                            }}
                                        >
                                            <img src={IconBaketShow} alt="IconBaketShow" />
                                            {business.subscriptionTitle === "آزمایشی" ? 'خرید اشتراک' : " تمدید / ارتقا اشتراک"}
                                        </div>
                                        {canDelete ? (
                                            <div
                                                onClick={() =>
                                                    dispatch(
                                                        setConfirm("آیا مطمئن هستید ؟", () =>
                                                            apiDeleteBusiness(business.id, token, dispatch, navigate)
                                                        )
                                                    )
                                                }
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModal"
                                            >
                                                <img src={IconDelete} alt="IconEdit" />
                                                <span>حذف کسب و کار</span>
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() =>
                                                    dispatch(
                                                        setConfirm("آیا مطمئن هستید ؟", () =>
                                                            apiLeaveBusiness(business.id, token, dispatch, navigate)
                                                        )
                                                    )
                                                }
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModal"
                                                className="flex items-center gap-2"
                                            >
                                                <LeaveIcon scale={0.8} />
                                                <span>ترک کسب و کار</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="header-item">
                                        <div>
                                            <div className="img-item-header">
                                                <img src={IconHome} alt="IconHome" />
                                            </div>
                                            <div className="text-header">{business.nickName}</div>
                                        </div>
                                        <div className="img-menu-header">
                                            {toggle && showMenu && menuBusinessId === business.id ? (
                                                <img src={IconMenuAz} alt="IconMenuAz"
                                                    onClick={() => showBusinessMenu()} />
                                            ) : (
                                                <img src={IconMenu} alt="IconMenu"
                                                    onClick={() => showBusinessMenu(business.id)} />
                                            )}
                                        </div>
                                    </div>
                                    <div className="body-item">
                                        <div className="div-access d-flex">
                                            <img src={IconKey} alt="IconKey" />
                                            سطح دسترسی
                                        </div>
                                        <div className="title-access">{business.userRole}</div>
                                    </div>
                                    <div className="body-item">
                                        <div className="div-access d-flex">
                                            <img src={IconNote} alt="IconNote" />
                                            اشتراک
                                        </div>
                                        <div
                                            className={
                                                business.subscriptionTitle === "منقضی شده"
                                                    ? "title-access-new-red"
                                                    : business.subscriptionTitle === "آزمایشی"
                                                        ? "title-access-new-blue"
                                                        : "title-access"
                                            }
                                        >
                                            {business.subscriptionTitle}
                                        </div>
                                    </div>
                                    <div className="body-item-2">
                                        <div className="div-access">تاریخ انقضا</div>
                                        <div className="title-access">{business.expirationAt}</div>
                                    </div>
                                    <div className="go-to-panel">
                                        <button
                                            type="submit"
                                            onClick={() => {
                                                console.log(business.subscriptionTitle, "business.subscriptionTitle business.subscriptionTitle ")
                                                if (business.subscriptionTitle === "منقضی شده") {
                                                    dispatch(setBusiness({ business }));
                                                    navigate("/business/extend");
                                                } else {
                                                    loadBusiness(business);
                                                }
                                            }}
                                        >
                                            {business.subscriptionTitle === "منقضی شده" ? "تمدید اشتراک" : "پنل حسابداری"}
                                            <img src={IconArrowLeft} alt="IconArrowLeft" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <a
                        className="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                        href="/business"
                        onClick={(e) => {
                            // navigate("/setupBusiness");
                            navigate("/business");
                            e.preventDefault();
                        }}
                    >
                        <div className="add-item-add-account">
                            <div className="warp-item-add-account">
                                <div className="img-new-add">
                                    <img className="img-add-new" src={IconAddNewAccount} alt="IconAddNewAccount" />
                                    <img
                                        className="img-add-new-hover"
                                        src={IconAddNewAccountHover}
                                        alt="IconAddNewAccountHover"
                                    />
                                </div>
                                <div className="style-add-new-account">
                                    <img src={addWork} alt="addWork" />
                                    افزودن کسب و کار جدید
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </WrapBody>
        </div>
    );
}
